import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import styles from './PlanGraphSlideV8.css';

const shortMonth = new Intl.DateTimeFormat('en-US', { month: 'short' });
const longMonth = new Intl.DateTimeFormat('en-US', { month: 'long' });

function getMonthFromNow(offset) {
    const now = new Date();

    return new Date(now.getFullYear(), now.getMonth() + offset, 1);
}

const GRID_ROWS = [60.21, 96.48, 132.75, 169.02, 205.28, 241.55];

const POINTS = [
    { x: 31.7, y: 218.88, className: styles.today },
    { x: 105.12, y: 142.84, className: styles.firstStory },
    { x: 188.53, y: 75, className: styles.memories },
    { x: 282.41, y: 60.21, className: styles.firstChapter }
];

function PlanGraphSlideV8({ spriteVersion }) {
    const labels = ['Today', ...[1, 2, 3].map(offset => shortMonth.format(getMonthFromNow(offset)))];

    return (
        <section className={styles.form}>
            <h2 className={styles.heading}>
                {'Your book’s first chapters, by '}
                <span className={styles.headingAccent}>{longMonth.format(getMonthFromNow(3))}</span>
            </h2>
            <p className={styles.description}>A few minutes at a time. You set the pace.</p>
            <figure className={styles.chart}>
                <div className={styles.canvas}>
                    <svg viewBox='0 0 328 274' className={styles.svg} aria-hidden='true'>
                        <defs>
                            <linearGradient
                                id='plan-graph-v8-area' x1='0' y1='89'
                                x2='0' y2='242' gradientUnits='userSpaceOnUse'
                            >
                                <stop stopColor='#1B4B38' stopOpacity='0.4' />
                                <stop offset='1' stopColor='#1B4B38' stopOpacity='0' />
                            </linearGradient>
                            <marker
                                id='plan-graph-v8-arrow' viewBox='0 0 10 10' refX='5'
                                refY='5' markerWidth='5' markerHeight='5'
                                orient='auto'
                            >
                                <path d='M0 0L10 5L0 10z' fill='#1B4B38' />
                            </marker>
                        </defs>
                        <g className={styles.grid}>
                            {GRID_ROWS.map(y => (
                                <line
                                    key={y} x1='18.1' x2='300.1'
                                    y1={y} y2={y}
                                />
                            ))}
                        </g>
                        <path className={styles.area} d='M31.7 219.33V242H282.4V61.11C130.98 53.41 101.52 166.75 70.24 193.95C38.95 221.15 31.7 219.33 31.7 219.33Z' fill='url(#plan-graph-v8-area)' />
                        <path
                            className={styles.line} pathLength='1' d='M31.7 219.33C31.7 219.33 38.95 221.15 70.24 193.95C101.52 166.75 130.98 53.41 274 60.5'
                            markerEnd='url(#plan-graph-v8-arrow)'
                        />
                        {POINTS.map(point => (
                            <g key={point.x} className={point.className}>
                                <line
                                    className={styles.stem} x1={point.x} x2={point.x}
                                    y1={point.y} y2='241.55'
                                />
                                <circle
                                    className={styles.dot} cx={point.x} cy={point.y}
                                    r='6.35'
                                />
                            </g>
                        ))}
                    </svg>
                    <p className={`${styles.tooltip} ${styles.nowTooltip} ${styles.today}`}>Now</p>
                    <p className={`${styles.tooltip} ${styles.storyTooltip} ${styles.firstStory}`}>First story told</p>
                    <p className={`${styles.tooltip} ${styles.memoriesTooltip} ${styles.memories}`}>Memories flooding back</p>
                    <p className={`${styles.tooltip} ${styles.chapterTooltip} ${styles.firstChapter}`}>
                        <EmojiIcon name='sparkles' version={spriteVersion} className={styles.sparkles} />
                        First chapter
                    </p>
                    {labels.map((label, index) => (
                        <span key={label} className={styles.monthLabel} style={{ left: `${POINTS[index].x / 328 * 100}%` }}>{label}</span>
                    ))}
                </div>
                <figcaption className={styles.caption}>*Illustrative example. Your pace and number of finished chapters may vary.</figcaption>
            </figure>
        </section>
    );
}

PlanGraphSlideV8.propTypes = {
    spriteVersion: PropTypes.string.isRequired
};

export {
    PlanGraphSlideV8
};
